import React, { useState } from 'react';
import { Icon } from '@iconify/react';

function Resources() {
    const [activeCategory, setActiveCategory] = useState('all');

    const opportunities = [
        {
            category: 'career',
            title: 'Program Manager - EducateHer',
            type: 'Full-time',
            location: 'Lagos, Nigeria',
            posted: '2 days ago',
            icon: 'mdi:briefcase'
        },
        {
            category: 'career',
            title: 'Data Analyst - Research & Evaluation',
            type: 'Full-time',
            location: 'Remote',
            posted: '1 week ago',
            icon: 'mdi:briefcase'
        },
        {
            category: 'fellowship',
            title: 'Aikpokpodion Fellowship 2025',
            type: 'Fellowship',
            location: 'Multiple Locations',
            posted: 'Application Open',
            icon: 'mdi:school'
        },
        {
            category: 'volunteer',
            title: 'Community Health Volunteer',
            type: 'Volunteer',
            location: 'Various Communities',
            posted: 'Ongoing',
            icon: 'mdi:hand-heart'
        },
        {
            category: 'internship',
            title: 'Research Intern - Geospatial Analysis',
            type: 'Internship',
            location: 'Abuja, Nigeria',
            posted: '3 days ago',
            icon: 'mdi:account-school'
        },
        {
            category: 'career',
            title: 'Communications Specialist',
            type: 'Contract',
            location: 'Hybrid',
            posted: '5 days ago',
            icon: 'mdi:briefcase'
        }
    ];

    const publications = [
        {
            title: 'Annual Impact Report 2024',
            description: 'Comprehensive overview of HSCF programs and impact across communities',
            type: 'Report',
            icon: 'mdi:file-chart',
            size: '2.5 MB'
        },
        {
            title: 'EducateHer Success Stories',
            description: 'Inspiring stories from our EducateHer scholarship recipients',
            type: 'Case Study',
            icon: 'mdi:book-open',
            size: '1.8 MB'
        },
        {
            title: 'Geospatial Innovation in Healthcare',
            description: 'Research compilation from RTYGIA award winners',
            type: 'Research Paper',
            icon: 'mdi:file-document',
            size: '3.2 MB'
        },
        {
            title: 'Community Health Implementation Guide',
            description: 'Best practices for community-based health interventions',
            type: 'Guide',
            icon: 'mdi:book',
            size: '4.1 MB'
        }
    ];

    const filteredOpportunities = activeCategory === 'all'
        ? opportunities
        : opportunities.filter(opp => opp.category === activeCategory);

    return (
        <div className="resources-page">
            {/* Page Header */}
            <section className="page-header resources-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <h1 className="page-title animate-slide-up">Resources</h1>
                            <p className="page-subtitle animate-slide-up delay-1">
                                Access publications, reports, and opportunities to engage with HSCF
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <div className="header-graphic animate-fade-in delay-2">
                                <Icon icon="material-symbols:library-books" className="header-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Publications & Reports */}
            <section className="publications-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Knowledge Base</span>
                        <h2 className="section-title">Publications & Reports</h2>
                        <p className="section-description">
                            Download our latest research, impact reports, and educational materials
                        </p>
                    </div>

                    <div className="row g-4">
                        {publications.map((pub, index) => (
                            <div key={index} className="col-lg-6">
                                <div className="publication-card">
                                    <div className="publication-icon">
                                        <Icon icon={pub.icon} />
                                    </div>
                                    <div className="publication-content">
                                        <div className="publication-type">{pub.type}</div>
                                        <h4>{pub.title}</h4>
                                        <p>{pub.description}</p>
                                        <div className="publication-meta">
                                            <span className="file-size">
                                                <Icon icon="mdi:file" /> {pub.size}
                                            </span>
                                            <button className="btn-download">
                                                <Icon icon="mdi:download" /> Download PDF
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-4">
                        <button className="btn btn-view-archive">
                            <Icon icon="mdi:archive" className="me-2" />
                            View Publication Archive
                        </button>
                    </div>
                </div>
            </section>

            {/* Opportunities */}
            <section className="opportunities-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Get Involved</span>
                        <h2 className="section-title">Opportunities</h2>
                        <p className="section-description">
                            Career openings, fellowships, internships, and volunteer positions
                        </p>
                    </div>

                    <div className="opportunities-filter">
                        <button
                            className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('all')}
                        >
                            <Icon icon="mdi:view-grid" />
                            All Opportunities
                        </button>
                        <button
                            className={`filter-btn ${activeCategory === 'career' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('career')}
                        >
                            <Icon icon="mdi:briefcase" />
                            Careers
                        </button>
                        <button
                            className={`filter-btn ${activeCategory === 'fellowship' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('fellowship')}
                        >
                            <Icon icon="mdi:school" />
                            Fellowships
                        </button>
                        <button
                            className={`filter-btn ${activeCategory === 'internship' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('internship')}
                        >
                            <Icon icon="mdi:account-school" />
                            Internships
                        </button>
                        <button
                            className={`filter-btn ${activeCategory === 'volunteer' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('volunteer')}
                        >
                            <Icon icon="mdi:hand-heart" />
                            Volunteer
                        </button>
                    </div>

                    <div className="opportunities-list">
                        {filteredOpportunities.map((opp, index) => (
                            <div key={index} className="opportunity-card">
                                <div className="opportunity-icon">
                                    <Icon icon={opp.icon} />
                                </div>
                                <div className="opportunity-content">
                                    <h4>{opp.title}</h4>
                                    <div className="opportunity-details">
                                        <span className="detail-item">
                                            <Icon icon="mdi:briefcase-outline" />
                                            {opp.type}
                                        </span>
                                        <span className="detail-item">
                                            <Icon icon="mdi:map-marker" />
                                            {opp.location}
                                        </span>
                                        <span className="detail-item">
                                            <Icon icon="mdi:clock-outline" />
                                            {opp.posted}
                                        </span>
                                    </div>
                                </div>
                                <div className="opportunity-action">
                                    <button className="btn btn-apply-opportunity">
                                        Apply Now
                                        <Icon icon="mdi:arrow-right" className="ms-2" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {filteredOpportunities.length === 0 && (
                        <div className="no-opportunities">
                            <Icon icon="mdi:information" />
                            <p>No opportunities available in this category at the moment.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Media Resources */}
            <section className="media-resources">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">For Media</span>
                        <h2 className="section-title">Media Resources</h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="media-card">
                                <Icon icon="mdi:image-multiple" className="media-icon" />
                                <h4>Photo Gallery</h4>
                                <p>High-resolution images from our programs and events</p>
                                <button className="btn btn-media">
                                    Access Gallery
                                    <Icon icon="mdi:arrow-right" className="ms-2" />
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="media-card">
                                <Icon icon="mdi:file-document-outline" className="media-icon" />
                                <h4>Press Releases</h4>
                                <p>Latest news and announcements from HSCF</p>
                                <button className="btn btn-media">
                                    View Releases
                                    <Icon icon="mdi:arrow-right" className="ms-2" />
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="media-card">
                                <Icon icon="mdi:palette" className="media-icon" />
                                <h4>Brand Assets</h4>
                                <p>Logos, brand guidelines, and design resources</p>
                                <button className="btn btn-media">
                                    Download Assets
                                    <Icon icon="mdi:arrow-right" className="ms-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Need Help?</span>
                        <h2 className="section-title">Frequently Asked Questions</h2>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="accordion" id="faqAccordion">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq1"
                                        >
                                            How can I apply for the EducateHer scholarship?
                                        </button>
                                    </h2>
                                    <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            Applications for EducateHer are open twice a year (January and July).
                                            Visit the EducateHer program page and complete the online application form.
                                            You'll need to submit academic transcripts, personal statement, and letters of recommendation.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq2"
                                        >
                                            What are the requirements for the RTYGIA award?
                                        </button>
                                    </h2>
                                    <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            RTYGIA applicants must be between 18-35 years old, enrolled in or graduated from
                                            a relevant program, and have a project that utilizes geospatial technology for social impact.
                                            Complete details are available on the RTYGIA program page.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq3"
                                        >
                                            How can I volunteer with HSCF?
                                        </button>
                                    </h2>
                                    <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            We welcome volunteers! Fill out the volunteer application form on our Contact page
                                            or check the Opportunities section above for specific volunteer positions.
                                            We'll match you with opportunities based on your skills and interests.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq4"
                                        >
                                            Where does my donation go?
                                        </button>
                                    </h2>
                                    <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            All donations go directly to funding our programs. You can choose to donate to a
                                            specific initiative (EducateHer, RTYGIA, etc.) or to our general fund.
                                            We maintain full transparency and provide detailed impact reports to all donors.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <p>Can't find what you're looking for?</p>
                                <a href="/contact" className="btn btn-contact-faq">
                                    <Icon icon="mdi:email" className="me-2" />
                                    Contact Us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Resources;
